module.exports = __webpack_public_path__ + "static/Logo-aba911357fa2d90e5dd0343c8596799d.svg";